module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/logos/Comchest-448507bf28abd23b79e41c2777feb6ee.png";